export default "__VITE_ASSET__Di4$CPvD__"